// Socket.IO client loaded via CDN in public/index.html (avoids webpack/socket.io-parser bundling issue)
// window.io is available globally after the CDN script loads

const LOCATION_SERVER = 'https://location.superkonnected.com';

// Type-only reference to avoid npm import
declare const io: (url: string, opts?: Record<string, any>) => any;

export interface PartnerLocationUpdate {
  userId: string;
  lat: number;
  lng: number;
  timestamp: number;
}

type PartnerLocationCallback = (update: PartnerLocationUpdate) => void;

class LocationSocketService {
  private socket: any = null;
  private partnerLocationCallback: PartnerLocationCallback | null = null;

  connect(connectionId: string, userId: string, userName: string): void {
    if (this.socket?.connected) return;

    // Use global io from CDN — not the npm package
    if (typeof io === 'undefined') {
      console.warn('[LocationSocket] socket.io CDN not loaded yet');
      return;
    }

    this.socket = io(LOCATION_SERVER, {
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 2000,
      reconnectionAttempts: 10,
    });

    this.socket.on('connect', () => {
      this.socket?.emit('join-connection', { connectionId, userId, userName });
    });

    this.socket.on('partner-location', (data: PartnerLocationUpdate) => {
      this.partnerLocationCallback?.(data);
    });

    this.socket.on('disconnect', () => {
      console.log('[LocationSocket] Disconnected');
    });
  }

  sendLocation(connectionId: string, userId: string, lat: number, lng: number): void {
    if (!this.socket?.connected) return;
    this.socket.emit('location-update', { connectionId, userId, lat, lng });
  }

  onPartnerLocation(callback: PartnerLocationCallback): void {
    this.partnerLocationCallback = callback;
  }

  disconnect(): void {
    this.socket?.disconnect();
    this.socket = null;
    this.partnerLocationCallback = null;
  }

  isConnected(): boolean {
    return this.socket?.connected ?? false;
  }
}

export const locationSocket = new LocationSocketService();
